import { render } from "./PhotoSideBarTabDeviceItem.vue?vue&type=template&id=7be036ed&scoped=true"
import script from "./PhotoSideBarTabDeviceItem.vue?vue&type=script&lang=js"
export * from "./PhotoSideBarTabDeviceItem.vue?vue&type=script&lang=js"

import "./PhotoSideBarTabDeviceItem.vue?vue&type=style&index=0&id=7be036ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be036ed"]])

export default __exports__